import { Injectable, PLATFORM_ID, Inject } from '@angular/core';

// declare var NProgress: any;
// import NProgress from 'nprogress';

// NProgress.configure({ showSpinner: true });
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from "ngx-ui-loader"; // Import NgxUiLoaderService
import { environment } from "../../../environments/environment"
import { isPlatformBrowser, isPlatformServer } from
  '@angular/common';
  import { Router, NavigationEnd, RoutesRecognized } from '@angular/router';
  import { filter, pairwise } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HelperService {
  private data = {};
  private metaTitle = {};
  private headingData = {};
  private trendingData = {};
  private publisherData = {};

  public loaderStart() {
    // NProgress.start();
  }

  public loaderStop() {
    // NProgress.done();
  }
  private history = [];
  private audioPlayerList = {};
  private audioList = new BehaviorSubject({});
  audioList$ = this.audioList.asObservable();

  changeAudioData(data) {
    this.audioList.next(data)
  }

  constructor(private toastr: ToastrService, private router: Router, private ngxService: NgxUiLoaderService, @Inject(PLATFORM_ID) private platform: Object) { }
  //Function to set value in localStorage
  public lsSetItem(key: any, value: any) {
    if (isPlatformBrowser(this.platform)) {

      return localStorage.setItem(key, JSON.stringify(value));
    }
  }

  //Function to get value from localStorage
  public lsGetItem(key: any) {
    if (isPlatformBrowser(this.platform)) {

      return JSON.parse(localStorage.getItem(key) || '{}');
    }
  }

  //Function to remove a value from localStorage
  public lsRemoveItem(key: any) {
    if (isPlatformBrowser(this.platform)) {

    return localStorage.removeItem(key);
    }
  }

  //Function to clear localStorage
  public lsClear() {
    if (isPlatformBrowser(this.platform)) {

    return localStorage.clear();
    }
  }

  //Function to set value in sessionStorage
  public ssSetItem(key: any, value: any) {
    if (isPlatformBrowser(this.platform)) {

      return sessionStorage.setItem(key, JSON.stringify(value));
    }
  }

  //Function to get value from sessionStorage
  public ssGetItem(key: any) {
    if (isPlatformBrowser(this.platform)) {

      return JSON.parse(sessionStorage.getItem(key) || '{}');
    }
  }

  //Function to remove a value from sessionStorage
  public ssRemoveItem(key: any) {
    if (isPlatformBrowser(this.platform)) {

    return sessionStorage.removeItem(key);
    }
  }

  //Function to remove a value from sessionStorage
  public ssClear() {
    if (isPlatformBrowser(this.platform)) {

    return sessionStorage.clear();
    }
  }

  public setMetaTitleOption(value: any) {
    this.metaTitle = value;
  }

  public getMetaTitleOption() {
    return this.metaTitle;
  }

  public setHeadingOption(value: any) {
    this.headingData = value;
  }

  public getHeadingOption() {
    return this.headingData;
  }

  public setTrendingOption(value: any) {
    this.trendingData = value;
  }

  public getTrendingOption() {
    return this.trendingData;
  }

  public setPublisherOption(value: any) {
    this.publisherData = value;
  }

  public getPublisherOption() {
    return this.publisherData;
  }


  public setOption(value: any) {
    this.data = value;
  }

  public getOption() {
    return this.data;
  }


  public setAudioPlayerList(value: any) {
    this.audioPlayerList = value;
  }

  public getAudioPlayerList() {
    return this.audioPlayerList;
  }

  //Function to display success Toaster message
  public notifySuccess(msg: any) {
    // console.log("msg", msg)
    this.toastr.success(msg, '', { timeOut: 2000 });
  }

  //Function to display info Toaster message
  public notifyInfo(msg: any) {
    this.toastr.info(msg, '', { timeOut: 2000 });

  }

  //Function to display warning Toaster message
  public notifyWarnig(msg: any) {
    this.toastr.warning(msg, '', { timeOut: 2000 });

  }


  //Function to display error Toaster message
  public notifyError(msg: any) {
    this.toastr.error(msg, '', { timeOut: 2000 });

  }

  //ngx loader
  public ngxloaderStart(loader: any) {
    this.ngxService.startLoader(loader); // start foreground spinner of the loader "loader-01" with 'default' taskId

  }

  public ngxloaderStop(loader: any) {
    this.ngxService.stopLoader(loader); // stop foreground spinner of the loader "loader-01" with 'default' taskId
  }


  public loadRouting(): void {
    // this.router.events
    //   .pipe(filter(event => event instanceof NavigationEnd))
    //   .subscribe(({ urlAfterRedirects }: NavigationEnd) => {
    //     // this.history = [...this.history, urlAfterRedirects];
    //     this.history = [this.history, urlAfterRedirects];
    //   });

//       this.router.events
// .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
// .subscribe((events: RoutesRecognized[]) => {
//   this.history = [this.history, events[0].urlAfterRedirects];
//   console.log('previous url', events[0].urlAfterRedirects);
//   console.log('current url', events[1].urlAfterRedirects);
// });
this.router.events
.pipe(filter(event => event instanceof NavigationEnd))
.subscribe((event: NavigationEnd) => {
  // console.log('prev:', event.url);
  // this.previousUrl = event.url;
  this.history = [this.history, event.url];
});
  }

  public getHistory(): string[] {
    return this.history;
  }

  public getPreviousUrl(): string {
    return this.history[this.history.length - 2] || '/';
  }

}
